import { RouterProvider } from 'react-router';
import { router } from './routes';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './components/auth-provider';
import { ThemeProvider } from './components/theme-provider';
import { Analytics } from '@vercel/analytics/react';

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
          <Toaster position="top-right" richColors />
          <RouterProvider router={router} />
          <Analytics />
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}